import React, { useEffect, useState } from 'react';
import { FormCheckbox } from 'shards-react';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ConditionOptionsData, ConditionOptionsType } from '../../types/condition';
import { RootState, useDispatch, useSelector } from '../../redux/store';
import { addOptionToConditionCustomize, removeOptionFromConditionCustomize } from '../../redux/slices/condition';
import { MANAGE_CONDITION_TYPES } from '../../constants';

/**
 * ConditionCustomizeのチェックボックス用レンダラ
 * @param params: ICellRendererParams
 * @returns React.ReactElement
 */
const SelectConditionCustomizeRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params);
  const dispatch = useDispatch();
  const data: ConditionOptionsType = params.data;
  const { condition, selectedViewMode } = useSelector((state: RootState) => state.condition);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(true);
  const detail: ConditionOptionsData | undefined = condition
    ? {
        ...data,
        conditionId: condition.id,
        conditionType: MANAGE_CONDITION_TYPES.CUSTOMIZE,
      }
    : undefined;

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  // }, []);

  // 編集可能な状態かをチェックする
  useEffect(() => {
    if (selectedViewMode === 'EDITING' && (condition?.conditionStatus === 'EDITING' || condition?.conditionStatus === 'APPROVED')) {
      setIsEditable(true);
    } else {
      setIsEditable(false);
    }
  }, [selectedViewMode, condition?.conditionStatus]);

  // EVENT HANDLER
  // ================================================================================

  const handleChange = (): void => {
    if (isEditable) {
      // unchecked -> checkedの場合
      if (detail && !isChecked) {
        dispatch(addOptionToConditionCustomize(detail));
        // checked -> uncheckedの場合
      } else if (detail && isChecked) {
        dispatch(removeOptionFromConditionCustomize(detail));
      } else {
        // do nothing
      }
      // setIsChecked(!isChecked);
    }
  };

  // VIEW
  // ================================================================================

  return (
    <div className="text-center">
      <FormCheckbox className="m-0" size="sm" inline disabled={!isEditable} checked={isChecked} onChange={handleChange} />
    </div>
  );
};

export default SelectConditionCustomizeRenderer;
